<ll-titulo>Mi Progreso</ll-titulo>

<grafico-mi-progreso-cb [evaluacionTipo]="tipoInstrumento"></grafico-mi-progreso-cb>
